import { ReactNode } from 'react'

type FormSectionProps = {
  title?: string
  description?: string
  children: ReactNode
}

export function FormSection({ title, description, children }: FormSectionProps) {
  return (
    <div className="space-y-4">
      {(title || description) && (
        <div className="space-y-0.5 pb-3 border-b border-border/40">
          {title && <h2 className="text-sm font-medium">{title}</h2>}
          {description && <p className="text-[13px] text-muted-foreground">{description}</p>}
        </div>
      )}
      {children}
    </div>
  )
}
